import Vue from "vue";
import './plugins/vuetify/vuetify'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import axios from 'axios';

// Import Raven, Sentry's SDK
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';


if (process.env.NODE_ENV === 'production') {
  // Here goes the DSN
  Raven
    .config('https://f0eb8f13842146a58a574e9bd92f641d@sentry.io/1477285', {
      // We also track the project's release to benefit from some of Sentry's advanced features
   //  'release': config.SENTRY_RELEASE,
    })
    .addPlugin(RavenVue, Vue)
    .install();
} else {
  // You may remove this once you are sure everything works fine
  console.debug('Not configuring Sentry, environment is', process.env.NODE_ENV);
}
Vue.config.productionTip = false;

const token = localStorage.getItem('access_token');
if (token) {
  axios.defaults.headers.common['Authorization'] = `JWT ${token}`
}

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount("#app");
